exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/**\n* DEFINE VARIABLES\n*/\n.fade-enter-active[data-v-12c26260],\n.fade-leave-active[data-v-12c26260] {\n  -webkit-transition: opacity .3s;\n  transition: opacity .3s;\n}\n.fade-enter[data-v-12c26260],\n.fade-leave-to[data-v-12c26260] {\n  opacity: 0;\n}\n.border-bottom[data-v-12c26260] {\n  width: 80%;\n  background-color: #e6e6e6;\n  height: 1px;\n  margin-top: 30px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-12c26260","scoped":true,"hasInlineConfig":false}!./node_modules/less-loader/dist/cjs.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/modal/HistoryModalSection.vue
// module id = 1450
// module chunks = 1